var _module_exports = "<a>\n    {{result}}\n</a>";;
var path = '/builds/observability/imm/signalview/src/legacy/app/typeaheadDropDown/defaultResultRenderer.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;